import useSystemDateTheme from "hooks/useSystemDateTheme";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import AboutCourseTab from "views/home/courses/CourseView/tabs/AboutCourseTab";
import OrderView from "views/home/orders/OrderView";
import { tabsIds } from "views/home/orders/OrderView/orderPage.types";
import { OrderInfoTab } from "views/home/orders/OrderView/tabs/OrderInfoTab";
import {CourseOrderStatus} from "../../../../services/courseOrder/models/CourseOrderType";

const ViewPublishedCourseOrder = () => {
  const { t } = useTranslation("Orders");
  const navigate = useNavigate();
  const { toSystemThemeDateFormat } = useSystemDateTheme();

  return (
    <OrderView
      withImage
      breadcrumbs={({ orderId, serialNumber }) => [
        {
          localizationKey: "myPublishedWork",
          path: "/home/authorOrders/MyPublishedWork",
          menuItemId: "allOrders",
        },
        {
          localizationKey: "order-number",
          path: `/home/orders/unpublishedOrder/${orderId}`,
          localizationParameters: { orderNumber: serialNumber },
        },
      ]}
      defaultTabId="info"
      tapsToView={({ courseData, courseOrderData, openedTask, activePage, setActivePage, userType ,setTriggerOrderUpdate}) => {
        return [
          {
            id: tabsIds.info,
            title: t("info"),
            content: (
              <OrderInfoTab
                setActivePage={setActivePage}
                activePage={activePage}
                activeSectionsIds={["applicantInfoWithDetails"]}
                userType={userType}
                courseOrder={courseOrderData}
                course={courseData}
                openedTask={openedTask}
                setTriggerOrderUpdate={setTriggerOrderUpdate}
              />
            ),
          },
          {
            id: tabsIds.courseInfo,
            title: t("aboutCourse"),
            content: <AboutCourseTab course={courseData} />,
          },
        ];
      }}
      userType="StudentForPublishedOrder"
      headersToView={({ courseOrderData }) =>
          !courseOrderData
              ? []
              : [
                  {
                      title: t("orderNumber"),
                      value: courseOrderData?.serialNumber ?? "",
                  },
                  {
                      title: t("applicationDate"),
                      value: toSystemThemeDateFormat(courseOrderData?.submissionDate), //TODO": return id
                  },
                  courseOrderData?.centreManagement?   {
                          title: t("researchCenter"),
                          value: `${courseOrderData?.centreManagement?.displayName ?? ""}`,
                      }:
                      {
                          title: t("OrderType"),
                          value: `${courseOrderData?.publishingOrderType?.publishingOrderTypeDetail?.displayName ?? ""}`,
                      },

                  {
                      title: t("subspecialty"),
                      value: courseOrderData.scientificSpecialization.scientificSpecializationDetail.displayName,
                  },
                  {
                      title: t("languageOfScientificPublishing"),
                      value: courseOrderData.languageOfScientific?.languageOfScientificDetail?.displayName,
                  },

                  {
                      title: t("typeOfScientificPublishing"),
                      value: courseOrderData.typeOfScientific?.typeOfScientificDetail?.displayName,
                  },
                  {
                      title: t("scientificClassification"),
                      value: courseOrderData.scientificClassification.scientificClassificationDetail.displayName,
                  }

              ]
      }
      leftSection={({ courseOrderData }) => {
          const status = Object.values(CourseOrderStatus).find((s) => s.id === courseOrderData?.courseOrderStatusId);
          const className = status ? `bg-${status?.color} text-${status?.color}` : "bg-primary text-primary";

          return (
              <span className={`badge bg-opacity-10 ${className} rounded-4  py-2`}>{courseOrderData?.courseOrderStatus}</span>
          );
      }}
    />
  );
};

export default ViewPublishedCourseOrder;
